import {
  Component,
  NgModule,
  ViewChild,
  EventEmitter,
  Output,
  Input,
  SimpleChanges,
  OnChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { Router } from '@angular/router';
import {
  DxButtonModule,
  DxDataGridComponent,
  DxDataGridModule,
  DxDropDownButtonModule,
  DxPopoverModule,
  DxScrollViewModule,
  DxSelectBoxModule,
  DxTextBoxModule,
  DxToolbarModule,
} from 'devextreme-angular';
import { DxDataGridTypes } from 'devextreme-angular/ui/data-grid';
import { DxTabsTypes } from 'devextreme-angular/ui/tabs';
import { exportDataGrid as exportToPdf } from 'devextreme/pdf_exporter';
import { exportDataGrid as exportToXLSX } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { StatusIndicatorComponent } from '../status-indicator/status-indicator.component';
import { Task, taskPriorityList, taskStatusList } from '../task';
import { PlanningTaskDetailsComponent } from '../planning-task-details/planning-task-details.component';

@Component({
  selector: 'dk-task-list-grid',
  templateUrl: './task-list-grid.component.html',
  styleUrls: ['./task-list-grid.component.scss'],
  standalone: true,
  imports: [
    DxButtonModule,
    DxDataGridModule,
    DxDropDownButtonModule,
    DxSelectBoxModule,
    DxTextBoxModule,
    DxToolbarModule,
    HttpClientModule,
    CommonModule,
    StatusIndicatorComponent,
    DxPopoverModule,
    DxScrollViewModule,
    PlanningTaskDetailsComponent,
  ],
})
export class TaskListGridComponent implements OnChanges {
  @ViewChild(DxDataGridComponent, { static: false }) grid: DxDataGridComponent;

  @Input() dataSource: Task[];

  @Output() tabValueChanged: EventEmitter<any> = new EventEmitter<
    EventEmitter<any>
  >();

  tasks: any[];

  priorityList = taskPriorityList;

  statusList = taskStatusList;

  isLoading = true;

  useNavigation = true;
  public showTaskDetail = false;

  constructor(private router: Router) {}

  refresh() {
    this.grid.instance.refresh();
  }

  showColumnChooser() {
    this.grid.instance.showColumnChooser();
  }

  search(text: string) {
    this.grid.instance.searchByText(text);
  }

  onExportingToPdf() {
    const doc = new jsPDF();
    exportToPdf({
      jsPDFDocument: doc,
      component: this.grid.instance,
    }).then(() => {
      doc.save('Tasks.pdf');
    });
  }

  onExportingToXLSX() {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Tasks');

    exportToXLSX({
      component: this.grid.instance,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(
          new Blob([buffer], { type: 'application/octet-stream' }),
          'Tasks.xlsx'
        );
      });
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['dataSource']) {
      this.tasks = changes['dataSource'].currentValue.filter(
        (item: any) => !!item.status && !!item.priority
      );
    }
  }

  onRowPreparedGrid = (e: DxDataGridTypes.RowPreparedEvent<Task, number>) => {
    const { rowType, rowElement, data } = e;

    if (rowType === 'header') return;

    if (data.status === 'Completed') {
      rowElement.classList.add('completed');
    }
  };

  toogleUseNavigation = () => {
    this.useNavigation = !this.useNavigation;
  };

  tabsItemClick = (e: DxTabsTypes.ItemClickEvent) => {
    this.tabValueChanged.emit(e);
  };

  navigateToDetails = (e: DxDataGridTypes.RowClickEvent) => {
    if (this.useNavigation && e.rowType !== 'detailAdaptive') {
      this.router.navigate(['/main/task/detail']);
    }
  };

  test(e: DxDataGridTypes.RowClickEvent) {
    this.showTaskDetail = true;
  }
  closedPopover(e: any) {
    this.showTaskDetail = false;
  }
}
